export default __webpack_public_path__ + "static/media/arrow-up-grey.719d198c.svg";